export default [
  {
    field: 'dataCriacao',
    id: "dataCriacao",
    label: "Data",
    minWidth: 10,
  },
  {
    field: 'titulo',
    id: "titulo",
    label: "Título",
    minWidth: 50,
    align: "left",
  },
  {
    field: 'descricao',
    id: "descricao",
    label: "Descrição",
    minWidth: 50,
    align: "left",
  },
  {
    field: 'tipo',
    id: "tipo",
    label: "Tipo",
    minWidth: 50,
    align: "left",
  },
  {
    field: 'ufs',
    id: "ufs",
    subfield: "sigla",
    label: "UF",
    minWidth: 50,
    align: "left",
  },
  {
    field: 'status',
    id: "status",
    label: "Ações",
    minWidth: 100,
    align: "left",
  },
]